var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletConnectWOborder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 28,
    viewBox: "0 0 44 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 28,
    fill: "#E8E8E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Borrower Flow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-46498 -620C-46498 -621.105 -46497.1 -622 -46496 -622H940C941.105 -622 942 -621.105 942 -620V1634C942 1635.1 941.105 1636 940 1636H-46496C-46497.1 1636 -46498 1635.1 -46498 1634V-620Z",
    fill: "#4732D4",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46496 -612H940V-632H-46496V-612ZM932 -620V1634H952V-620H932ZM940 1626H-46496V1646H940V1626ZM-46488 1634V-620H-46508V1634H-46488ZM-46496 1626C-46491.6 1626 -46488 1629.59 -46488 1634H-46508C-46508 1640.62 -46502.6 1646 -46496 1646V1626ZM932 1634C932 1629.58 935.582 1626 940 1626V1646C946.629 1646 952 1640.63 952 1634H932ZM940 -612C935.578 -612 932 -615.587 932 -620H952C952 -626.622 946.633 -632 940 -632V-612ZM-46496 -632C-46502.6 -632 -46508 -626.628 -46508 -620H-46488C-46488 -615.582 -46491.6 -612 -46496 -612V-632Z",
    fill: "#4732D4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Dashboard - Main - Borrow - 1440px",
    clipPath: "url(#clip0_12085_161900)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1464,
    transform: "translate(-698 -422)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Main Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Data Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal_2"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_12085_161900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-554 -170C-554 -172.209 -552.209 -174 -550 -174H30C32.2091 -174 34 -172.209 34 -170V514C34 516.209 32.2092 518 30 518H-550C-552.209 518 -554 516.209 -554 514V-170Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "atom/modal-content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    clipPath: "url(#clip2_12085_161900)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart + X-axis"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chart background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Horizontal grid lines"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid line 1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Right grid line",
    d: "M10 -14V242",
    stroke: "black",
    strokeOpacity: 0.08,
    strokeLinecap: "square"
  }))))))), /*#__PURE__*/React.createElement("path", {
    d: "M-553.5 -170C-553.5 -171.933 -551.933 -173.5 -550 -173.5H30C31.933 -173.5 33.5 -171.933 33.5 -170V514C33.5 515.933 31.933 517.5 30 517.5H-550C-551.933 517.5 -553.5 515.933 -553.5 514V-170Z",
    stroke: "#E6E6E6"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Overlay",
    x: -698,
    y: -422,
    width: 1440,
    height: 1464,
    fill: "black",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("g", {
    id: "Modal_3"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_12085_161900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-238 -98C-238 -100.209 -236.209 -102 -234 -102H278C280.209 -102 282 -100.209 282 -98V226C282 228.209 280.209 230 278 230H-234C-236.209 230 -238 228.209 -238 226V-98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "atom/modal-content_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 164,
    transform: "translate(-238 -30)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-box",
    clipPath: "url(#clip4_12085_161900)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "wallet connect"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.39785 6.00375C16.3613 -0.834584 27.6513 -0.834584 34.6146 6.00375L35.4529 6.82674C35.5355 6.90715 35.6012 7.00339 35.6461 7.10974C35.6909 7.21609 35.7141 7.3304 35.7141 7.44588C35.7141 7.56136 35.6909 7.67567 35.6461 7.78202C35.6012 7.88837 35.5355 7.98461 35.4529 8.06502L32.5859 10.8803C32.5014 10.9626 32.3883 11.0086 32.2706 11.0086C32.1529 11.0086 32.0398 10.9626 31.9554 10.8803L30.8022 9.74772C25.9444 4.97706 18.0681 4.97706 13.2103 9.74772L11.9752 10.9606C11.8907 11.0429 11.7776 11.0889 11.6599 11.0889C11.5422 11.0889 11.4291 11.0429 11.3447 10.9606L8.47796 8.14531C8.39533 8.06489 8.32963 7.96866 8.28477 7.8623C8.23991 7.75595 8.21679 7.64165 8.21679 7.52617C8.21679 7.41069 8.23991 7.29638 8.28477 7.19003C8.32963 7.08368 8.39533 6.98744 8.47796 6.90703L9.39785 6.00375ZM40.5436 11.8262L43.0951 14.3319C43.1777 14.4123 43.2434 14.5085 43.2883 14.6149C43.3331 14.7212 43.3562 14.8355 43.3562 14.951C43.3562 15.0665 43.3331 15.1808 43.2883 15.2871C43.2434 15.3935 43.1777 15.4897 43.0951 15.5701L31.5903 26.8686C31.2421 27.2105 30.6776 27.2105 30.3293 26.8686L22.1639 18.8497C22.1216 18.8086 22.0651 18.7856 22.0062 18.7856C21.9474 18.7856 21.8909 18.8086 21.8486 18.8497L13.6835 26.8686C13.3352 27.2105 12.7707 27.2105 12.4225 26.8686L0.917426 15.57C0.834791 15.4896 0.769096 15.3933 0.724232 15.287C0.679368 15.1806 0.65625 15.0663 0.65625 14.9509C0.65625 14.8354 0.679368 14.7211 0.724232 14.6147C0.769096 14.5084 0.834791 14.4121 0.917426 14.3317L3.46889 11.826C3.81697 11.4842 4.3815 11.4842 4.72973 11.826L12.8953 19.8451C12.9824 19.9305 13.1234 19.9305 13.2106 19.8451L21.3758 11.826C21.7238 11.4842 22.2884 11.4842 22.6366 11.826L30.8022 19.8451C30.8892 19.9305 31.0303 19.9305 31.1174 19.8451L39.2828 11.8262C39.631 11.4843 40.1954 11.4843 40.5436 11.8262Z",
    fill: "#006FFF"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M-237.5 -98C-237.5 -99.933 -235.933 -101.5 -234 -101.5H278C279.933 -101.5 281.5 -99.933 281.5 -98V226C281.5 227.933 279.933 229.5 278 229.5H-234C-235.933 229.5 -237.5 227.933 -237.5 226V-98Z",
    stroke: "#E6E6E6"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12085_161900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1464,
    fill: "white",
    transform: "translate(-698 -422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_12085_161900"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-554 -170C-554 -172.209 -552.209 -174 -550 -174H30C32.2091 -174 34 -172.209 34 -170V514C34 516.209 32.2092 518 30 518H-550C-552.209 518 -554 516.209 -554 514V-170Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_12085_161900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 540,
    height: 312,
    fill: "white",
    transform: "translate(-530 -30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_12085_161900"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-238 -98C-238 -100.209 -236.209 -102 -234 -102H278C280.209 -102 282 -100.209 282 -98V226C282 228.209 280.209 230 278 230H-234C-236.209 230 -238 228.209 -238 226V-98Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_12085_161900"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(-6 -14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnectWOborder);
export default __webpack_public_path__ + "static/media/walletConnectWOborder.e57bdee7a86cd0e77a30052d65c82b67.svg";
export { ForwardRef as ReactComponent };